"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSchema = void 0;
const zod_1 = require("zod");
const __1 = require("..");
const opportunity_1 = require("../opportunity/opportunity");
exports.CustomerSchema = __1.BaseCustomerSchema.extend({
    lastOrder: __1.OrderSchema.pick({
        id: true,
        channelOrderId: true,
        createdAt: true,
        orderTotal: true,
        status: true,
    }).optional(),
    itemsOfInterest: __1.BaseItemSchema.partial().required({ id: true }).array(),
    categoriesOfInterest: __1.BaseItemCategorySchema.partial().required({ id: true }).array(),
    opportunities: zod_1.z.array(opportunity_1.OpportunitySchema).optional(),
});
//# sourceMappingURL=customer.js.map